<template>
    <div class="flex justify-end mb-4">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Buscar..."
        class="px-4 py-2 border rounded md:w-1/4 w-1/2 "
        @input="$emit('update-query', searchQuery)"
      />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      initialQuery: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        searchQuery: this.initialQuery,
      };
    },
  };
  </script>
  